import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

import { lottieThoughtLeadership } from "./lottie.js";
import revealWords from "./revealWords.js";
import { carousel } from "./carousel.js";
import { basicSlideshow } from './swiper.js';
import { highlightsSlideshow } from './splide.js';

/* plugins */
Alpine.plugin(persist);
Alpine.plugin(intersect);
Alpine.plugin(collapse);

/* components */
Alpine.data("lottieThoughtLeadership", lottieThoughtLeadership);
Alpine.data("revealWords", revealWords);
Alpine.data("carousel", carousel);
Alpine.data("basicSlideshow", basicSlideshow);
Alpine.data("highlightsSlideshow", highlightsSlideshow);

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
